import { useState } from "react";

interface Props<TArgs, TResponse> {
  queryFn: (args: TArgs) => Promise<TResponse>;
  onSuccess?: (data: TResponse) => void;
}

const useMutation = <TArgs = void, TResponse = void>({
  queryFn,
  onSuccess,
}: Props<TArgs, TResponse>) => {
  const [error, setError] = useState<Error | undefined>();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<TResponse | undefined>();

  const mutate = async (args: TArgs) => {
    setLoading(true);
    try {
      const response = await queryFn(args);
      setData(response);
      onSuccess?.(response);
    } catch (error) {
      setError(error as Error);
    } finally {
      setLoading(false);
    }
  };

  return {
    error,
    data,
    loading,
    mutate,
  };
};

export default useMutation;
